import React from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    StoreType,
    setCcReviewComplianceFormalSelectedItemIds,
    setCcReviewComplianceSelectedItemIds,
} from "client/store"
import {
    CheckButton,
    TableGroupedIds,
    TableNestedIds,
} from "client/components"

interface SelectAllProps {
    title?: string
    formal: boolean
}

const InputSelectAll = ({
    title = null,
    formal,
}: SelectAllProps) => {
    const itemGroupedIds = useSelector((state: StoreType) => state.ccReviewCompliance.itemGroupedIds)

    const formalSelectedItemIds = useSelector((state: StoreType) => state.ccReviewCompliance.formalSelectedItemIds)
    const formalVisibleItemIds = useSelector((state: StoreType) => state.ccReviewCompliance.formalVisibleItemIds)
    const reviewSelectedItemIds = useSelector((state: StoreType) => state.ccReviewCompliance.reviewSelectedItemIds)
    const reviewVisibleItemIds = useSelector((state: StoreType) => state.ccReviewCompliance.reviewVisibleItemIds)
    const selectedItemIds = formal ? formalSelectedItemIds : reviewSelectedItemIds
    const visibleItemIds = formal ? formalVisibleItemIds : reviewVisibleItemIds

    const dispatch = useDispatch()

    const visibleSelected = selectedItemIds.filter((id) => visibleItemIds.includes(id))
    const selectedAll = visibleItemIds.length === visibleSelected.length && visibleItemIds.length > 0

    const selectAll = () => {
        if (selectedAll) {
            if (formal) dispatch(setCcReviewComplianceFormalSelectedItemIds([]))
            else dispatch(setCcReviewComplianceSelectedItemIds([]))
        } else {
            // select all visible items with sub-items
            const selected: number[] = []

            const addNestedItems = (nested: readonly TableNestedIds[]) => {
                nested.forEach((item) => {
                    selected.push(Number(item.id))
                    addNestedItems(item.nestedIds)
                })
            }
            const checkNestedGroups = (nested: readonly TableGroupedIds[]) => {
                nested.forEach((group) => {
                    group.nestedIds.forEach((nestedItem) => { // top level of nested items
                        const itemId = Number(nestedItem.id)
                        if (visibleItemIds.includes(itemId)) {
                            selected.push(itemId)
                            addNestedItems(nestedItem.nestedIds)
                        }
                    })
                    checkNestedGroups(group.nestedGroupedIds)
                })
            }
            checkNestedGroups(Object.values(itemGroupedIds))

            if (formal) {
                dispatch(setCcReviewComplianceFormalSelectedItemIds(selected))
                dispatch(setCcReviewComplianceSelectedItemIds([])) // clear selection of other table
            } else {
                dispatch(setCcReviewComplianceSelectedItemIds(selected))
                dispatch(setCcReviewComplianceFormalSelectedItemIds([])) // clear selection of other table
            }
        }
    }

    return (
        <CheckButton
            title={title}
            checked={selectedAll}
            padding={false}
            margin={false}
            onChange={selectAll}
        />
    )
}
export default InputSelectAll
